import React, { useEffect, useState } from "react";
import { config } from "../config/monitoring";

export default function StatusBanner({
  className = "",
  runtimeMode = null,
  runtimeNotifications = null,
}) {
  const [mode, setMode] = useState(runtimeMode || config.monitoring.mode);
  const [notificationsConfigured, setNotificationsConfigured] = useState(
    runtimeNotifications || config.notifications.configured,
  );

  useEffect(() => {
    // If runtime props are provided, use them
    if (runtimeMode !== null) {
      setMode(runtimeMode);
    }
    if (runtimeNotifications !== null) {
      setNotificationsConfigured(runtimeNotifications);
    }
  }, [runtimeMode, runtimeNotifications]);

  const live = mode === "LIVE";

  return (
    <div
      className={`w-full rounded-xl p-3 md:p-4 shadow-sm border ${
        live ? "bg-green-50 border-green-200" : "bg-yellow-50 border-yellow-200"
      } ${className}`}
    >
      <p className="text-sm md:text-base">
        <strong>BuildBright Billing Alerts</strong> are running in{" "}
        <strong>{mode}</strong>. Synthetic checks may time out by design.
        {!notificationsConfigured && (
          <>
            {" "}
            <strong> Notifications aren't configured.</strong> Alerts won't be
            delivered until you add a channel.
          </>
        )}
      </p>
      <p className="mt-1 text-xs text-gray-600">
        Notifications:{" "}
        <strong>
          {notificationsConfigured ? "configured" : "not configured"}
        </strong>
      </p>
    </div>
  );
}
